import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "",
    user: null,
    uaa: null,
    isAuthenticated: false,
    selectedServices: [],
    //selectedCarrier: {},
    selectedManualClient: "",
    isnewClient:false,
    selectedDocumenttype: "",
    selectedClient: "",
    selectedSubofferingType: "",
    selectedCountry: "",
    selectedLawfirm: "",
    selectedIncidentType: "",
    selectedIncidentTypeTitle: "",
    selectedSubofferingTypeTitle: "",
    selectedLawfirmTitle: "",
    rateCardsDetails: null,
    masterServiceConfig:null,
    selectedAuthority: {},
    newClientRateCardData:{},
    rateCards:[],
    templateConfig: {},
    mastertemplateConfig: {},
    sowData:"",
    masterseConfig: {},
    baatemplateConfig: {},
    ndatemplateConfig: {},
    postirtemplateconfig: {},
    mdrtemplateconfig: {},
    mdrmtmtemplateconfig: {},
    servicesConfig: [],
    sow: {},
    placeholdervalues: [],
    servicesData: [],
    scopes: [],
    tasks: [],
    sowurl: "",
    masterData: {},
    rateCards:{},
    createAgainMode: false,
    amendmentMode: false,
    newMdrRenewal: false,
    soWSlug: "",
    sowClients: "",
    selectedClientDetails: {},
    selectedProject: {},
    rateCardDetails: {},
    //selectedBaaFilleId: "",
    //SelectedNdaFileid: ""
  },
  mutations: {
    login(state, token) {
      state.token = token;
      state.isAuthenticated = true;
    },
    populateMR(state, masterData) {
      state.masterData = masterData;
    },
    rateCardsList(state,rateCards){
      state.rateCards= rateCards.rateCards
    },
    settings(state, templateData) {
      //state.selectedServices = templateData.services;
      //state.selectedCarrier = templateData.carrier;
      state.selectedDocumenttype = templateData.documenttype;
      state.selectedManualClient = templateData.manualclient;
      state.isnewClient = templateData.isNewClient;
      state.selectedSubofferingType = templateData.subofferingType;
      state.selectedClient = templateData.client;
      state.selectedCountry = templateData.country;
      state.selectedLawfirm = templateData.lawfirm;
      state.selectedIncidentType = templateData.incidentType;
      state.selectedIncidentTypeTitle = templateData.incidentTypeTitle;
      state.selectedSubofferingTypeTitle = templateData.subofferingTypeTitle;
      state.selectedLawfirmTitle = templateData.lawfirmTitle;
    },
    authorityData(state, authData) {
      state.selectedAuthority = authData.authority;
    },
    newClientData(state,rateCardData){
      state.newClientRateCardData =rateCardData.rateCardDetails
    },
    templateconfig(state, templateConfig) {
      state.templateConfig = templateConfig;
    },
    mastertemplateconfig(state, mastertemplateconfig) {
      state.mastertemplateConfig = mastertemplateconfig;
    },
    sowData(state,sowData){
      state.sowData = sowData;
          },
    baatemplateconfig(state, templateConfig) {
      state.baatemplateConfig = templateConfig;
    },
    ndatemplateconfig(state, templateConfig) {
      state.ndatemplateConfig = templateConfig;
    },
    postirtemplateconfig(state, templateConfig) {
      state.postirtemplateconfig = templateConfig;
    },
    mdrtemplateconfig(state, templateConfig) {
      state.mdrtemplateconfig = templateConfig;
    },
    mdrmtmtemplateconfig(state, templateConfig) {
      state.mdrmtmtemplateconfig = templateConfig;
    },
    placeholders(state, values) {
      state.placeholdervalues = values;
    },
    createAgainMode(state, values) {
      state.createAgainMode = values;
    },
    newMdrRenewal(state, values) {
      state.newMdrRenewal = values;
    },
    servicesConfig(state, servicesConfig) {
      state.servicesConfig = servicesConfig;
    },
    servicedatascopes(state, data) {
      state.servicesData = data.servicesData;
      state.selectedServices = data.selectedServices;
    },
    servicedatatasks(state, servicesData) {
      _.each(servicesData, (serviceData) => {
        let stateServiceData = _.find(state.servicesData, (stateServiceData) => {
          return stateServiceData.slug === serviceData.Slug;
        });
        stateServiceData.Tasks = serviceData.Tasks;
        stateServiceData.PreSections = serviceData.PreSections;
        stateServiceData.PostSections = serviceData.PostSections;
        stateServiceData.Scopes = serviceData.Scopes;
        stateServiceData.ServiceOverview = serviceData.ServiceOverview;

        let serviceMasterRecord = _.find(state.masterData.services, (serviceMasterRecord) => serviceMasterRecord.slug === serviceData.servicecode);
        //We are doing this to ensure that on re-create of SoW the title
        //and description edited in the "Content" step are reflected in the re-create process
        serviceMasterRecord.Title = serviceData.serviceTitle;
        serviceMasterRecord.Description = serviceData.serviceDescription;
      });
    },
    init(state) {
      state.selectedServices = [];
      state.selectedLawfirm = "";
      state.selectedIncidentType = "";
      state.selectedIncidentTypeTitle = "";
      state.selectedSubofferingTypeTitle = "";
      state.selectedLawfirmTitle = "";
      state.selectedAuthority = "";
      state.newClientRateCardData="";
      state.templateConfig = {};
      state.mastertemplateConfig = {};
      state.sowData="";
      state.servicesConfig = {};
      state.sow = {};
      state.placeholdervalues = [];
      state.rateCards=[];
      state.servicesData = [];
      state.scopes = [];
      state.tasks = [];
      state.sowurl = "";
      state.createAgainMode = false;
      state.amendmentMode = false;
      state.newMdrRenewal = false;
      state.rateCardsDetails=null;
      state.masterServiceConfig=null;
      (state.baatemplateConfig = {}), (state.ndatemplateConfig = {}), (state.postirtemplateconfig = {}), (state.mdrtemplateconfig = {}), (state.mdrmtmtemplateconfig = {}), (state.selectedManualClient = ""),(state.isnewClient = false), (state.selectedDocumenttype = ""), (state.selectedSubofferingType = ""), (state.selectedCountry = ""), (state.selectedClient = ""), (state.sowClients = "");
    },
    initSoW(state, sowState) {
      if (sowState) {
        state.selectedCountry = sowState.selectedCountry || "USA";
        state.selectedDocumenttype = sowState.selectedDocumenttype;
        state.selectedManualClient = sowState.selectedManualClient;
        state.isnewClient=sowState.isnewClient;
        state.selectedSubofferingType = sowState.selectedSubofferingType || "IR";
        state.selectedClient = sowState.selectedClient;
        state.selectedServices = sowState.selectedServices;
        state.selectedLawfirm = sowState.selectedLawfirm;
        state.selectedIncidentType = sowState.selectedIncidentType;
        state.selectedIncidentTypeTitle = sowState.selectedIncidentTypeTitle;
        state.selectedSubofferingTypeTitle = sowState.selectedSubofferingTypeTitle;
        state.selectedLawfirmTitle = sowState.selectedLawfirmTitle;
        state.selectedAuthority = sowState.selectedAuthority;
        state.newClientRateCardData= sowState.newClientRateCardData;
        state.templateConfig = sowState.templateConfig;
        state.mastertemplateConfig = sowState.mastertemplateConfig;
        state.sowData=sowState.sowData;
        state.servicesConfig = sowState.servicesConfig;
        state.placeholdervalues = sowState.placeholdervalues;
        state.rateCardsDetails=sowState.rateCardsDetails;
        state.masterServiceConfig= sowState.masterServiceConfig;
        state.selectedProject = sowState.selectedProject;
        state.rateCardDetails = sowState.rateCardDetails;
        state.servicesData = sowState.servicesData;
        state.scopes = sowState.scopes;
        state.tasks = sowState.tasks;
        state.masterData = sowState.masterData;
        state.rateCards= sowState.rateCards;
        state.selectedTemplateConfig = sowState.selectedTemplateConfig;
        state.selectedMasterTemplateConfig = sowState.selectedMasterTemplateConfig;
        state.createAgainMode = true;
        state.amendmentMode = sowState.IsAmendment;
        state.newMdrRenewal = sowState.newMdrRenewal;
        state.soWSlug = sowState.SoWSlug;
      }
    },
    user(state, account) {
      state.user = account.user;
      sessionStorage.setItem("username", account.user.name);
    },
    uaa(state, uaa) {
      state.uaa = uaa;
    },
    sowClients(state, sowClients) {
      state.sowClients = sowClients;
    },
    selectedClientDetails(state, selectedClientDetails) {
      state.selectedClientDetails = selectedClientDetails;
    },
    setrateCardsDetails(state, details){
      state.rateCardsDetails = details;
    },
    setMasterServiceConfig(state, details){
      state.masterServiceConfig = details;
    },
    setProjectDetails(state, details) {
      state.selectedProject = details;
    },
    setRateCardDetails(state, details) {
      state.rateCardDetails = details;
    },
  },
  getters: {
    selectedClientDetails: (state) => state.selectedClientDetails,
    sowClients: (state) => state.sowClients,
    createAgainMode: (state) => state.createAgainMode,
    amendmentMode: (state) => state.amendmentMode,
    newMdrRenewal: (state) => state.newMdrRenewal,
    soWSlug: (state) => state.soWSlug,
    state: (state) => state,
    token: (state) => state.token,
    user: (state) => state.user,
    uaa: (state) => state.uaa,
    isAuthenticated: (state) => state.isAuthenticated,
    masterData: (state) => state.masterData,
    rateCards:(state)=>state.rateCards,
    //selectedCarrier: state => state.selectedCarrier,
    selectedDocumenttype: (state) => state.selectedDocumenttype,
    selectedManualClient: (state) => state.selectedManualClient,
    isnewClient: (state) => state.isnewClient,
    selectedSubofferingType: (state) => state.selectedSubofferingType,
    selectedClient: (state) => state.selectedClient,
    selectedCountry: (state) => state.selectedCountry,
    selectedLawfirm: (state) => state.selectedLawfirm,
    selectedIncidentType: (state) => state.selectedIncidentType,
    selectedIncidentTypeTitle: (state) => state.selectedIncidentTypeTitle,
    selectedSubofferingTypeTitle: (state) => state.selectedSubofferingTypeTitle,
    selectedLawfirmTitle: (state) => state.selectedLawfirmTitle,
    selectedAuthority: state => state.selectedAuthority,
    newClientRateCardData:state=>state.newClientRateCardData,
    selectedServices: (state) => state.selectedServices,
    selectedTemplateConfig: (state) => state.templateConfig,
    selectedMasterTemplateConfig: (state) => state.mastertemplateConfig,
    sowData:(state) =>state.sowData,
    selectedBaaTemplateConfig: (state) => state.baatemplateConfig,
    selectedNdaTemplateConfig: (state) => state.ndatemplateConfig,
    selectedPostIRTemplateConfig: (state) => state.postirtemplateconfig,
    selectedMDRTemplateConfig: (state) => state.mdrtemplateconfig,
    selectedMDRMtMTemplateConfig: (state) => state.mdrmtmtemplateconfig,
    placeholderValues: (state) => state.placeholdervalues,
    rateCardsDetails: (state) => state.rateCardsDetails,
    masterServiceConfig: (state) => state.masterServiceConfig,
    selectedProject: (state) => state.selectedProject,
    rateCardDetails: (state) => state.rateCardDetails,
    servicesConfig: (state) => state.servicesConfig,
    servicesData: (state) => state.servicesData,
    hasMasterData: (state) => (state.masterData && state.masterData.documents && state.masterData.documents.length) > 0,
    hasTemplate: (state) => state.templateConfig && state.templateConfig.slug != null,
    hasBaaTemplate: (state) => state.baatemplateConfig && state.baatemplateConfig.slug != null,
    hasNdaTemplate: (state) => state.ndatemplateConfig && state.ndatemplateConfig.slug != null,
    hasPostIRTemplate: (state) => state.postirtemplateconfig && state.postirtemplateconfig.slug != null,
    hasMDRTemplate: (state) => state.mdrtemplateconfig && state.mdrtemplateconfig.slug != null,
    hasMDRMtMTemplate: (state) => state.mdrmtmtemplateconfig && state.mdrmtmtemplateconfig.slug != null,
    hasServicesConfig: (state) => state.servicesConfig && state.servicesConfig.length > 0,
    selectedLawfirmMasterRecord: function (state) {
      let lawfirmMasterRecord = _.find(state.masterData.lawfirms, (lf) => {
        return lf.slug === state.selectedLawfirm;
      });
      return lawfirmMasterRecord;
    },
    // selectedCarrierMasterRecord: function(state) {
    //   let carrierMasterRecord = _.find(state.masterData.carriers, lf => {
    //     return (lf.Slug = state.selectedCarrier);
    //   });
    //   return carrierMasterRecord;
    // }
  },
  actions: {},
});
